export { default as InternationalTrademarkRegistrationStyle } from './InternationalTrademarkRegistration.module.scss';
